import { hashStringToNumber } from './hashStringToNumber'

export const shouldSampleSession = (userId: string | undefined, samplingRate: number): boolean => {
  if (userId) {
    const hash = hashStringToNumber(userId)
    return (hash % 100) / 100 < samplingRate
  }
  return false
}
